/* HEVOlogica Motion – Progressive Enhancement:
   Inhalte sind per Default sichtbar. JS versteckt nur Elemente unterhalb
   des Viewports kurzzeitig (.hevo-pre) und blendet sie beim Scrollen ein.
   Schlägt irgendetwas fehl, bleibt alles sichtbar. */
(function () {
  document.documentElement.classList.add('hevo-motion');

  function init() {
    try {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var els = Array.prototype.slice.call(document.querySelectorAll('.hevo-reveal'));
      var vh = window.innerHeight;
      var pending = [];
      els.forEach(function (e) {
        var r = e.getBoundingClientRect();
        if (r.top > vh * 0.92) { e.classList.add('hevo-pre'); pending.push(e); }
      });
      if (!pending.length) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var el = en.target;
            io.unobserve(el);
            // Reflow erzwingen, damit die Transition greift
            void el.offsetWidth;
            requestAnimationFrame(function () { el.classList.remove('hevo-pre'); });
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -4% 0px' });
      pending.forEach(function (e) { io.observe(e); });

      // Sicherheitsnetz: nach 6s wird alles gezeigt, egal was ist
      setTimeout(function () {
        pending.forEach(function (e) { e.classList.remove('hevo-pre'); });
      }, 6000);
    } catch (err) {
      document.querySelectorAll('.hevo-pre').forEach(function (e) { e.classList.remove('hevo-pre'); });
    }
  }

  function initVideos() {
    try {
      var vids = document.querySelectorAll('video[data-hevo-lazy]');
      if (!vids.length) return;
      if (!('IntersectionObserver' in window)) {
        vids.forEach(function (v) {
          if (v.dataset.src && !v.querySelector('source')) {
            var s = document.createElement('source'); s.src = v.dataset.src; s.type = 'video/mp4';
            v.appendChild(s); v.load(); v.play().catch(function () {});
          }
        });
        return;
      }
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            if (v.dataset.src && !v.querySelector('source')) {
              var s = document.createElement('source'); s.src = v.dataset.src; s.type = 'video/mp4';
              v.appendChild(s); v.load();
            }
            v.play().catch(function () {});
          } else { v.pause(); }
        });
      }, { rootMargin: '250px' });
      vids.forEach(function (v) { vio.observe(v); });
    } catch (err) { /* Videos zeigen Poster als Fallback */ }
  }

  function run() { init(); initVideos(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
})();
